"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnounceTable = void 0;
const mithril_1 = __importDefault(require("mithril"));
const announce_1 = require("../../../model/announce");
const confirm_1 = require("../../../utils/confirm");
const helpers_1 = require("../../../utils/helpers");
const table_renderers_1 = require("../../../utils/table_renderers");
const right_panel_1 = require("../../../widgets/right_panel");
const table_1 = require("../../../widgets/table");
const announce_form_1 = require("./announce_form");
exports.AnnounceTable = (0, table_1.createTable)({
    id: "announceTable",
    filters: [],
    provider: announce_1.AnnounceProvider,
    title: "Annonces",
    topMenuRight: () => {
        return [
            (0, mithril_1.default)("a", { class: "button is-success with-margin", onclick: () => { announce_form_1.AnnounceForm.show(); } }, (0, helpers_1.iconSpan)("fa-plus", "is-small"), (0, mithril_1.default)("span", "Nouvelle Annonce"))
        ];
    },
    fields: [
        {
            name: "id",
            sortable: true,
            label: "n°"
        },
        {
            name: "title",
            sortable: false,
            label: "Titre",
        },
        {
            name: "venue",
            sortable: false,
            label: "Établissement",
            renderer: table_renderers_1.TableRenderers.resourceLink("venues", "show", (mdl) => mdl.venue.id, (mdl) => mdl.venue.name)
        },
        {
            name: "starts_at",
            sortable: true,
            label: "Date d'application",
            renderer: (obj) => {
                return [obj.starts_at, obj.ends_at].map(x => x && (0, helpers_1.tag)((0, helpers_1.formatTime)(x)));
            }
        },
        {
            name: "creator",
            sortable: false,
            label: "Créée par",
            renderer: (x) => {
                return (0, mithril_1.default)("div", x.creator.name);
            }
        },
    ],
    actions: (obj) => {
        return (0, helpers_1.buttonGroup)((0, mithril_1.default)("a", { title: "Afficher", class: "button", onclick: () => { right_panel_1.RightPanel.open("announces", obj.id, "show"); } }, (0, helpers_1.iconSpan)("fa-eye")), (0, mithril_1.default)("button.button.is-danger", { onclick: () => {
                confirm_1.Confirm.confirm("Cette opération est irréversible. Etes-vous sûr?").then(() => __awaiter(void 0, void 0, void 0, function* () {
                    yield announce_1.AnnounceProvider.delete(obj.id);
                    exports.AnnounceTable.fetch();
                    right_panel_1.RightPanel.close();
                }));
            } }, "Supprimer"));
    }
});
